import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import type { PublicationItem } from '../model';
import type { PublicationCategory } from './model';
import { SeeMorePublicationItem } from './see-more-publication-item';

interface SeeMorePublicationsList {
  titleKey?: IntlKey;
  onClose: () => void;
  items: ReadonlyArray<PublicationItem>;
  categories?: ReadonlyArray<PublicationCategory>;
}

export const ScrollableFixedHeightDiv = styled.div`
  height: 75vh;
  overflow-y: auto;
`;
export const SeeMorePublicationsList: FC<SeeMorePublicationsList> = ({ onClose, items, categories, titleKey }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <button
        className="btn btn-flat-secondary btn-xl align-self-end m-2"
        onClick={onClose}
        data-e2e="close-see-more"
        aria-label="Close"
      >
        <i className="icon icon-lg">close</i>
      </button>
      {titleKey !== undefined && <h3 className="mb-4 px-md-5">{formatMessage({ id: titleKey })}</h3>}
      <ScrollableFixedHeightDiv className="container px-md-5">
        {items.map(({ imageUrl, id, title, documentUrl, publicationDate, categoryId, videoId }) => (
          <SeeMorePublicationItem
            key={id ?? title}
            image={imageUrl}
            title={title}
            categoryId={categoryId}
            categories={categories}
            documentUrl={documentUrl}
            publishedOn={publicationDate}
            videoId={videoId}
          />
        ))}
      </ScrollableFixedHeightDiv>
    </>
  );
};

SeeMorePublicationsList.displayName = 'SeeMorePublicationsList';
